import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@roger/ui-components';

const SignedOutPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <div className='min-h-screen bg-background flex items-center justify-center p-4'>
      <Card className='w-full max-w-md'>
        <CardHeader className='text-center'>
          {/* Roger Logo */}
          <img
            src='https://cdn.prod.website-files.com/6707130d88e878564ebeead2/6707e3f0baed2cc2cc663543_Group%205301.svg'
            alt='Roger Logo'
            className='mx-auto mb-6 h-12 w-auto'
            style={{ maxHeight: 48 }}
          />

          <Typography variant='h3' as='h1' className='mb-2'>
            You've been signed out
          </Typography>

          <Typography variant='lead' className='text-muted-foreground'>
            Thank you for using Roger Healthcare
          </Typography>
        </CardHeader>

        <CardContent className='space-y-6'>
          <div className='text-center'>
            <Button
              type='button'
              onClick={handleSignIn}
              className='w-full'
              variant='default'
              size='lg'
            >
              Sign In Again
            </Button>
          </div>

          <div className='text-center'>
            <Typography variant='small' className='text-muted-foreground'>
              Need help? Contact support at{' '}
              <a
                href='mailto:support@rogerhealthcare.com'
                className='text-primary hover:underline'
              >
                support@rogerhealthcare.com
              </a>
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SignedOutPage;
